import {
    getList as _getList,
    getOneById as _getOneById,
    getAll as _getAll,
    add as _add,
    update as _update,
    deleteAll as _deleteAll,
} from "../../../api";
import { dateToString } from "utils/dateUtils";

const BASE_URL = "/settings/forms";
const DEFAULT_LIST_DATA = {
    filter: {},
    orderBy: "id",
    orderDirection: "desc",
    pageNumber: 0,
    pageSize: 15,
};

function normalizeFormData(data) {
    const { expires: expiresInMillis } = data;

    const expires = new Date(expiresInMillis);

    return {
        ...data,
        expires,
        expiresString: dateToString(expires, false),
    };
}

function normalizeData(data) {
    return data.map(normalizeFormData);
}

/** Current versions without their field mappings: get a form by id to get them. */
export function getCurrent({ onSuccess, onError }) {
    _getAll({
        url: `${BASE_URL}/current`,
        onSuccess,
        onError,
        normalizer: normalizeData,
    });
}

export function getList({ onSuccess, onInfo, onError, data = DEFAULT_LIST_DATA }) {
    _getList({ url: BASE_URL, data, onSuccess, onInfo, onError, normalizer: normalizeData });
}

export function getOneById({ id, onSuccess, onError }) {
    _getOneById({
        url: `${BASE_URL}/${id}`,
        onSuccess,
        onError,
        normalizer: normalizeFormData,
    });
}

export function add({ payload, onSuccess, onError }) {
    _add({ url: BASE_URL, data: payload, onSuccess, onError });
}

export function update({ payload, onSuccess, onError }) {
    _update({ url: `${BASE_URL}/${payload.id}`, data: payload, onSuccess, onError });
}

export function deleteAll({ ids, onSuccess, onError }) {
    _deleteAll({ url: BASE_URL, data: { ids }, onSuccess, onError });
}

export function rollback({ id, onSuccess, onError }) {
    _add({ url: `${BASE_URL}/${id}/rollback`, onSuccess, onError });
}
